/**
 * Set classes to body
 */
export default {
    head() {
        return {
            bodyAttrs: {
                class: this.bodyClasses || '',
            },
        };
    },
};
